export default {
  "cycleProFeature": {
    "title": "Pro Cycle Feature",
    "description": "You can use this feature or other complete features by activating Pro Cycle.",
    "more": "Find out more"
  },
  "dateTimeFilter": {
    "dateAfter": "Date after",
    "dateBefore": "Date before",
    "time": "Time",

    "all": "All",
    "am": "AM",
    "pm": "PM",

    "apply": "Apply",
    "reset": "Reset",
  },
  "multipleImageInput": {
    "camera": "Camera",
    "image": "Gallery"
  },
  "onboardNewFeatureModal": {
    "showFeature": "Show Features",
    "skipFeature": "Close",
    "newFeature": "New Feature",
    "titleFeature1": "Cost Monitoring",
    "textFeature1": "Monitor operational cost estimation every day as an alternative to assessing potential profits/losses.",
    "titleFeature2": "Operational Cost Chart",
    "textFeature2": "Graphic display estimation to make it easier to see potential profits/losses until the end of the cycle.",
    "contentOverview": "Swipe this area to see the value of farm costs/operations.",
    "contentItemOverview": "Select a box to see details per pool.",
    "contentTabOverview": "You can view other information more quickly through tabs.",
    "contentGraphOverview": "You can also see the cost trend in the graph menu.",
    "contentTabGraphOverview": "New Feature!\nCharts for cost monitoring",
    "contentItemGraphOverview": "Read the costs estimation through the graph, you can also scroll down to see other graphs.",
    "contentFilterGraphOverview": "View more charts faster through this filter.",
  },
  "onboardModal": {
    "welcomeTitle": "Welcome to JALA",
    "welcomeDescription": "Follow the instructions to begin your cultivation journey.",
    "welcomeAction": "Follow Instruction",
    "welcomeSkipAction": "Skip for Now",
    "welcomeBanner": "If you're a farmer, switch to cultivation mode",
    "welcomeMenuOther": "Discover other services to learn about cultivation and to experience cultivation simulations.",
    "welcomeOverview": "Monitor all your ponds primary data here.",
    "welcomeOverviewCreateSomething": "Start your cultivation journey by creating %{something}",
    "welcomeMenu": "Explore other services that will assist you in your cultivation journey.",
    "welcomeHome": "",
    "welcomeQuickInput": "Enter your cultivation data here.",
    "welcomeActivity": "Manage daily activities without fear of missing out.",
    "welcomeMonitoring": "Get your ponds analyzed here.",

    "consultationTitle": "Now you can consult about Shrimp Farming",
    "consultationDescription": "Having problems in Farming? Let's consult your problem with the experts from Jala.",

    "newMenuTitle": "New! To do feature",
    "newMenuSubtitle": "Manage daily activities and input cultivation data more easily and quickly"
  },
  "offlineMode": {
    "resetRequireInternet": "Reset require internet connectivity",
  },
  "shrimpPriceFilter": {
    "country": "Country",
    "region": "Region",
    "time": "Price Update",
    "supplier": "Supplier",

    "regionLabel": "Select Region",
    "timeLabel": "Select Price Update",
    "now": "Latest",
    "week": "> 1 Week",
    "month": "> 1 Month",

    "all": "All",
    "verified": "Verified",

    "apply": "Apply",
    "reset": "Reset",
  },
  "listEmpty": {
    "text": "There's no record saved yet"
  },
  "listNetworkError": {
    "refreshPage": "Refresh Page"
  },

  "astoCoachmark": {
    "connection": "Indicator of Asto has been connected by Bluetooth or Wifi or not",
    "resetButton": "Reset to return changes to their original state",
    "saveButton": "You can use the 'Save' feature before uploading it",
    "uploadButton": "Upload the data that you have input",
    "feedTable": "You can use the data that has been input in the feed input feature",
    "todayFeed": "Input the total feeding in a day",
    "todayFeedNormal": "Adjust the portion with the feed hours in the pond",
    "nextDayFeed": "You can also add the feed data for one week",
  }
}
